import * as React from 'react';
import { SVGProps } from 'react';

const SvgShowOutlined = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" role="img" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.156 11.647a12.942 12.942 0 0 0 1.655 2.129c1.275 1.32 3.031 2.518 5.189 2.518s3.914-1.198 5.19-2.518a12.947 12.947 0 0 0 1.654-2.129 12.95 12.95 0 0 0-1.655-2.129C15.915 8.198 14.159 7 12 7S8.086 8.198 6.81 9.518a12.944 12.944 0 0 0-1.654 2.13Zm14.844 0 .889-.459-.002-.002-.003-.006-.009-.017a6.033 6.033 0 0 0-.145-.26 14.944 14.944 0 0 0-2.102-2.774C17.177 6.626 14.933 5 12 5 9.067 5 6.823 6.626 5.372 8.129a14.95 14.95 0 0 0-2.102 2.774 8.833 8.833 0 0 0-.145.26l-.01.017-.002.006-.001.002s-.001.001.888.46l-.889-.459a1 1 0 0 0 0 .916L4 11.647l-.889.458v.002l.002.002.003.005.009.017a4.794 4.794 0 0 0 .145.26 14.946 14.946 0 0 0 2.102 2.774c1.451 1.503 3.695 3.13 6.628 3.13 2.933 0 5.177-1.627 6.628-3.13a14.94 14.94 0 0 0 2.102-2.774 9.285 9.285 0 0 0 .145-.26l.01-.017.002-.006.001-.002s.001-.001-.888-.459Zm0 0 .889.458c.148-.287.148-.63 0-.917l-.889.46Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 10.53c-.681 0-1.182.528-1.182 1.117 0 .59.5 1.118 1.182 1.118.681 0 1.182-.529 1.182-1.118 0-.59-.5-1.118-1.182-1.118Zm-3.182 1.117c0-1.75 1.453-3.118 3.182-3.118 1.729 0 3.182 1.368 3.182 3.118 0 1.75-1.453 3.118-3.182 3.118-1.729 0-3.182-1.368-3.182-3.118Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgShowOutlined;
